import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useAuth from '../hooks/useAuth';
import { logout } from '../store/store';
import authService from '../services/authService';

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, userRole } = useAuth();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleLogout = async () => {
    try {
      await authService.signOut();
      dispatch(logout());
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="bg-primary text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 text-2xl font-bold">
            <div className="w-8 h-8 bg-accent rounded-full"></div>
            <span>RailOne</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="hover:text-accent transition">Home</Link>
            {user && (
              <>
                <Link to="/search" className="hover:text-accent transition">Search Trains</Link>
                {userRole === 'passenger' && (
                  <>
                    <Link to="/bookings" className="hover:text-accent transition">My Bookings</Link>
                    <Link to="/profile" className="hover:text-accent transition">Profile</Link>
                  </>
                )}
                {userRole === 'ttr' && (
                  <>
                    <Link to="/ttr-dashboard" className="hover:text-accent transition">TTR Dashboard</Link>
                  </>
                )}
                {userRole === 'admin' && (
                  <>
                    <Link to="/admin-dashboard" className="hover:text-accent transition">Admin Dashboard</Link>
                  </>
                )}
              </>
            )}
          </div>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="relative">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="flex items-center space-x-2 hover:bg-blue-600 px-3 py-2 rounded transition"
                >
                  <img
                    src={user.photoURL || 'https://via.placeholder.com/32'}
                    alt={user.displayName}
                    className="w-8 h-8 rounded-full"
                  />
                  <span className="hidden sm:block text-sm">{user.displayName}</span>
                </button>

                {menuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white text-gray-800 rounded shadow-lg">
                    <Link
                      to="/profile"
                      className="block px-4 py-2 hover:bg-gray-100"
                      onClick={() => setMenuOpen(false)}
                    >
                      Profile
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 rounded hover:bg-blue-600 transition"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="px-4 py-2 bg-accent text-gray-900 rounded hover:bg-yellow-500 transition"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
